import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main ion-padding-horizontal" }

import BaseLayout from "@/modules/General/components/BaseLayout.vue";
import { IonText } from "@ionic/vue";
import { computed, onBeforeMount } from "vue";
import router from "@/router";
import { RouteNamesEnum } from "@/const/routes";
import { useUserStore } from "../store/userStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundPage',
  setup(__props) {

const user = computed(() => useUserStore()?.user);
onBeforeMount(() => {
  if(!user.value) {
    router.push({name: RouteNamesEnum.Login})
  }
})

return (_ctx: any,_cache: any) => {
  return (user.value)
    ? (_openBlock(), _createBlock(BaseLayout, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonText), null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Page not found")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})